import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useI18n } from '../i18n';

const SEOHead = ({ 
  title,
  description,
  image = null,
  url = null 
}) => {
  const location = useLocation();
  const { ogLocale, t } = useI18n();
  
  // URL dinamico basato sulla location
  const pageUrl = url || `https://app.wanderbuddy.com${location.pathname}`;
  
  // Immagine di default se non specificata
  const ogImage = image || 'https://app.wanderbuddy.com/og-default.png';
  
  // Tipo di contenuto dinamico
  const getContentType = () => {
    if (location.pathname.includes('/trip/') || location.pathname.includes('/share/trip/')) {
      return 'article';
    }
    if (location.pathname.includes('/profile/')) {
      return 'profile';
    }
    return 'website';
  };
  const resolvedTitle = title || t('seo.default_title');
  const resolvedDesc = description || t('seo.default_desc');

  return (
    <Helmet>
      {/* Meta tags base */}
      <title>{resolvedTitle}</title>
      <meta name="description" content={resolvedDesc} />
      
      {/* Open Graph Tags */}
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={resolvedDesc} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content={getContentType()} />
      <meta property="og:site_name" content="WanderBuddy" />
      <meta property="og:locale" content={ogLocale} />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedTitle} />
      <meta name="twitter:description" content={resolvedDesc} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:site" content="@WanderBuddy" />
      
      {/* Image Meta Tags */}
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:type" content="image/png" />
      
      {/* Structured Data per Google */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "MobileApplication",
          "name": "WanderBuddy",
          "description": resolvedDesc,
          "applicationCategory": "TravelApplication",
          "operatingSystem": "iOS",
          "url": pageUrl,
          "downloadUrl": "https://apps.apple.com/app/id6737308693",
          "image": ogImage,
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "EUR"
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "ratingCount": "500+"
          },
          "publisher": {
            "@type": "Organization",
            "name": "Spheral",
            "url": "https://spheral.co"
          }
        })}
      </script>
      
      {/* Additional meta tags */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Spheral" />
      <meta name="language" content="Italian" />
      
      {/* Mobile specific */}
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content="WanderBuddy" />
      
      {/* Preconnect per performance */}
      <link rel="preconnect" href="https://apps.apple.com" />
      <link rel="preconnect" href="https://app.wanderbuddy.com" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={pageUrl} />
    </Helmet>
  );
};

export default SEOHead;
